module.exports = {
    path: '/asset-life',
    component: () => import('@hs/HealthState'),
    children: [
        {
            name: 'home',
            path: '',
            alias: 'sites',
            component: () => import('@hs/components/Assets/AssetList'),
            meta: { module: 'hs' }
        },
        {
            path: 'exports',
            component: () => import('@hs/components/Ports/Exports'),
            meta: { module: 'hs' }
        },
        {
            path: 'imports',
            component: () => import('@hs/components/Ports/Imports'),
            meta: { module: 'hs' }
        },
        {
            name: 'profile',
            path: '/profile',
            component: () => import('@dash/components/Profile/UserInfo'),
            //meta: { module: 'profile' }
        },
        {
            path: 'sites/:site_id',
            alias: 'sites/:site_id/assets',
            component: () => import('@hs/components/Assets/AssetList'),
            meta: { module: 'hs' }
        },
        {
            path: 'sites/:site_id/assets/:asset_id',
            alias: 'sites/:site_id/assets/:asset_id/major-components',
            component: () => import('@hs/components/MajorComps/MajorCompPage'),
            meta: { module: 'hs' },
            children: [
                {
                    name: 'major-comp-list',
                    path: '',
                    component: () =>
                        import('@hs/components/MajorComps/MajorCompList')
                },
                {
                    name: 'asset-history',
                    path: 'history',
                    component: () =>
                        import('@hs/components/MajorComps/MajorCompEvents')
                },
                {
                    name: 'sentient-history',
                    path: 'sentient',
                    component: () =>
                        import(
                            '@hs/components/MajorComps/majorCompsSentientEvents'
                        )
                },
                {
                    name: 'notes',
                    path: 'notes',
                    component: () => import('@hs/components/MajorComps/Notes')
                }
            ]
        },
        {
            path:
                'sites/:site_id/assets/:asset_id/major-components/:major_component_id',
            component: () => import('@hs/components/SubComps/SubCompPage'),
            meta: { module: 'hs' },
            children: [
                {
                    name: 'powerflow',
                    path: 'diagram',
                    component: () => import('@hs/components/SubComps/Powerflow')
                },
                {
                    name: 'sub-comp-list',
                    path: 'bom',
                    alias: '',
                    component: () =>
                        import('@hs/components/SubComps/SubCompBom')
                },
                {
                    name: 'major-comp-history',
                    path: 'history',
                    component: () =>
                        import('@hs/components/SubComps/SubCompEvents')
                }
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/modules/asset-life/router.js